export default __webpack_public_path__ + "3fe4003754c263b5d31b0920b75e7ed5.png";